import { BlacksmithLogomarkAnimationSVG } from "@/components/BlacksmithLogoSVG";
import { SessionSkeleton } from "@/components/codesmith/SessionSkeleton";
import { RAIL_WIDTH } from "@/components/sidebar/railConstants";
import { isCodesmithPath } from "@/components/sidebar/useActiveApp";
import { SidebarInset, SidebarProvider } from "@/components/ui/sidebar";
import { useDashboardRouter as useRouter } from "@/hooks/useDashboardRouter";
import { useCodesmithSurface } from "@/lib/codesmithSurface";

// 28px clears the macOS traffic lights of a `titleBarStyle: "hiddenInset"`
// window and gives the frameless window something to drag by.
export function DesktopTitleBar() {
  return (
    <div
      aria-hidden
      className="h-7 shrink-0 bg-sidebar shadow-[inset_0_-1px_0_0_var(--color-border)] [-webkit-app-region:drag]"
    />
  );
}

/**
 * The window's drag handle for full-screen states that render without
 * DesktopTitleBar (auth loading, signed out, org access denied).
 */
export function DesktopDragRegion() {
  const desktop = useCodesmithSurface(null) === "desktop";
  if (!desktop) return null;
  return (
    <div
      aria-hidden
      className="fixed inset-x-0 top-0 z-50 h-7 [-webkit-app-region:drag]"
    />
  );
}

// `contain: layout` makes this box the containing block for fixed-position
// descendants, so SettingsSidebar's `fixed inset-y-0` starts below the title
// bar instead of under the traffic lights.
export const DESKTOP_BODY_CLASS = "relative min-h-0 flex-1 [contain:layout]";

/** AuthProvider's loading state, shaped like DesktopSidebarLayout. */
export function DesktopLayoutSkeleton() {
  const router = useRouter();
  return (
    <div className="flex h-dvh flex-col">
      <DesktopTitleBar />
      <SidebarProvider className={DESKTOP_BODY_CLASS}>
        <div className="flex flex-1 overflow-hidden">
          <div
            className="h-full shrink-0 bg-sidebar shadow-[inset_-1px_0_0_0_var(--color-border)]"
            style={{ width: RAIL_WIDTH }}
          />
          <SidebarInset className="flex-1 bg-transparent! overflow-hidden">
            {isCodesmithPath(router.pathname) ? (
              <SessionSkeleton />
            ) : (
              <div className="flex h-full items-center justify-center">
                <div className="w-32 h-32">
                  <BlacksmithLogomarkAnimationSVG />
                </div>
              </div>
            )}
          </SidebarInset>
        </div>
      </SidebarProvider>
    </div>
  );
}
